export class BomInfo {
    packingMaterialId: number;
    saleOrderId: number;
    itemId: number;
    constructor(packingMaterialId: number, saleOrderId: number, itemId: number) {
        this.packingMaterialId = packingMaterialId;
        this.saleOrderId = saleOrderId;
        this.itemId = itemId;
    }
}